// extracted by mini-css-extract-plugin
export var errorIcon = "_kl-1";
export var nameLogo = "_kl-0";